import styles from "components/input/InputLabel.module.scss";


export default function InputLabel(props) {
    const theme = props.theme || "default";

    return (
        <span className={styles[theme]}>{props.title}</span>
    )
}
